import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SelfieDialogService {
  private chatOpenSubject = new BehaviorSubject<boolean>(false);
  public isChatOpen$: Observable<boolean> = this.chatOpenSubject.asObservable();

  private dialogRefSubject = new BehaviorSubject<any>(null);
  public dialogRef$: Observable<any> = this.dialogRefSubject.asObservable();

  constructor() {}

  /**
   * Set chat drawer open state
   */
  setChatOpen(isOpen: boolean): void {
    this.chatOpenSubject.next(isOpen);
  }

  /**
   * Get current chat open state
   */
  getChatOpen(): boolean {
    return this.chatOpenSubject.value;
  }

  /**
   * Register dialog reference
   */
  setDialogRef(dialogRef: any): void {
    this.dialogRefSubject.next(dialogRef);
  }

  /**
   * Get current dialog reference
   */
  getDialogRef(): any {
    return this.dialogRefSubject.value;
  }

  /**
   * Hide selfie dialog (by closing it)
   */
  hideSelfieDialog(): void {
    const dialogRef = this.getDialogRef();
    if (dialogRef) {
      dialogRef.close();
      this.setDialogRef(null);
    }
  }

  /**
   * Show selfie dialog (reopen if it was previously open)
   * This is called from details.component.ts when chat closes
   */
  showSelfieDialog(openDialogFn: () => void): void {
    // The details component will handle reopening
    // This method is mainly for signaling
    openDialogFn();
  }
}


